import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M16 7h.01", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m20 7 2 .5-2 .5", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 18v3", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 17.75V21", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M7 18a6 6 0 0 0 3.84-10.61", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Bird";
const Bird = memo(themed(Icon));
export {
  Bird
};
//# sourceMappingURL=bird.js.map
